import { takeLatest, all, call, put } from "redux-saga/effects";
import {
  fetchPermissionData,
  setPermissionData,
  startAddRole,
  startDeleteRole,
  startUpdateRole,
  startRolesData,
  setRolesData,
  startRolesDataDropdown,
  setRolesDataDropdown,
  startFetchSingleRole,
  setSingleRoleData,
  completedFetch,
  roleSuccess,
  roleError,
  fetchRolePermissionIds,
  setRolePermissionIds,
  updateRolePermissions,
  updateRolePermissionsError,
  updateRolePermissionsSuccess,
  startReportingData,
  setReportingData,
  startReportingData2,
  setReportingData2,
  submitReport,
  setReport
} from "./roleDataSlice.selector";

import { addRoleAPI, updateRoleAPI, deleteRoleAPI, getRolesData, getRoleById, getAllPermission, getRoleAssignedPermissions, updateRolePermissionsAPI, getRolesDataDropdown, getAllReportingData, getAllReportingData2, submitReportApi } from "../../Api/RoleAPI/roleAPI";
import { setNotificationAction } from "../NotificationStore/notification.slice.selector";

function* submitReportWatcher() {
  yield takeLatest(submitReport.type, submitReportData);
}

function* submitReportData(payload) {
  try {
    const data = yield call(submitReportApi, payload.payload);
    yield put(setReport(data));
    yield put(
      setNotificationAction({
        message: data.message,
        variant: "success",
      })
    );
    yield put(completedFetch());
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.response.data.message,
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}


function* fetchReportingDataWatcher() {
  yield takeLatest(startReportingData.type, fetchAllReportingData);
}

function* fetchAllReportingData() {
  try {
    const data = yield call(getAllReportingData);
    yield put(setReportingData(data));
    yield put(completedFetch());
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.response.data.message,
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}

function* fetchReportingDataWatcher2() {
  yield takeLatest(startReportingData2.type, fetchAllReportingData2);
}

function* fetchAllReportingData2() {
  try {
    const data = yield call(getAllReportingData2);
    yield put(setReportingData2(data));
    yield put(completedFetch());
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.response.data.message,
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}










function* fetchPermission() {
  yield takeLatest(fetchPermissionData.type, fetchAllPermission);
}

function* fetchAllPermission() {
  try {
    const data = yield call(getAllPermission);
    yield put(setPermissionData(data));
    yield put(completedFetch());
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message || "Failed to fetch permissions",
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}

function* startAddRoleWatcher() {
  yield takeLatest(startAddRole.type, addRoleWorker);
}

function* addRoleWorker({ payload }) {
  try {
    yield call(addRoleAPI, payload);
    yield put(roleSuccess());
    yield put(
      setNotificationAction({
        message: "Role Added Successfully",
        variant: "success",
      })
    );
    yield put(startRolesData());
  } catch (error) {
    yield put(roleError());
    yield put(
      setNotificationAction({
        message: error.message || "Failed to add role",
        variant: "error",
      })
    );
  }
}

function* startUpdateRoleWatcher() {
  yield takeLatest(startUpdateRole.type, updateRoleWorker);
}

function* updateRoleWorker({ payload }) {
  try {
    yield call(updateRoleAPI, payload.id, payload.data);
    yield put(roleSuccess());
    yield put(startRolesData());
  } catch (error) {
    yield put(roleError());
    yield put(
      setNotificationAction({
        message: error.message || "Failed to update role",
        variant: "error",
      })
    );
  }
}


function* startDeleteRoleWatcher() {
  yield takeLatest(startDeleteRole.type, deleteRoleWorker);
}

function* deleteRoleWorker({ payload }) {
  try {
    yield call(deleteRoleAPI, payload);
    yield put(roleSuccess());
    yield put(
      setNotificationAction({
        message: "Role Deleted Successfully",
        variant: "success",
      })
    );
    yield put(startRolesData());
  } catch (error) {
    yield put(roleError());
    yield put(
      setNotificationAction({
        message: error.message || "Failed to delete role",
        variant: "error",
      })
    );
  }
}


function* startAllRoles() {
  yield takeLatest(startRolesData.type, setAllRolesData);
}

function* setAllRolesData({ payload }) {
  try {
    const data = yield call(getRolesData, payload);
    const roles = data?.data || [];
    yield put(setRolesData(roles));
    yield put(completedFetch());
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message || "Failed to fetch roles",
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}

function* startAllRolesDropdown() {
  yield takeLatest(startRolesDataDropdown.type, setAllRolesDataDropdown);
}

function* setAllRolesDataDropdown({ payload }) {
  try {
    const data = yield call(getRolesDataDropdown, payload);
    const roles = data?.data || [];
    yield put(setRolesDataDropdown(roles));
    yield put(completedFetch());
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message || "Failed to fetch roles",
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}



function* startSingleRole() {
  yield takeLatest(startFetchSingleRole.type, setSingleRole);
}

function* setSingleRole({ payload }) {
  try {
    const data = yield call(getRoleById, payload);
    const role = Array.isArray(data?.data) && data?.data.length > 0 ? data.data[0] : data?.data || null;
    yield put(setSingleRoleData(role));
    yield put(completedFetch());
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message || "Failed to fetch role",
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}

function* watchFetchRolePermissionIds() {
  yield takeLatest(fetchRolePermissionIds.type, fetchRolePermissionIdsWorker);
}

function* fetchRolePermissionIdsWorker({ payload }) {
  try {
    const data = yield call(getRoleAssignedPermissions, payload);
    yield put(setRolePermissionIds(data.permissionIds));
    yield put(completedFetch());
  } catch (error) {
    yield put(
      setNotificationAction({
        message: "Failed to load assigned permissions",
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}

function* watchUpdateRolePermissions() {
  yield takeLatest(updateRolePermissions.type, updateRolePermissionsWorker);
}

function* updateRolePermissionsWorker({ payload }) {
  try {
    const res = yield call(updateRolePermissionsAPI, payload);
    yield put(updateRolePermissionsSuccess());
    if (res?.success === true) {
      yield put(
        setNotificationAction({
          message: res?.message,
          variant: "success",
        })
      );
    } else {
      yield put(
        setNotificationAction({
          message: res?.message,
          variant: "error",
        })
      );
    }
    yield put(fetchRolePermissionIds(payload.roleId));
  } catch (error) {
    yield put(updateRolePermissionsError());
  }
}

export default function* roleDataSaga() {
  yield all([
    call(submitReportWatcher),
    call(fetchReportingDataWatcher),
    call(fetchReportingDataWatcher2),
    call(fetchPermission),
    call(startAllRoles),
    call(startAllRolesDropdown),
    call(startSingleRole),
    call(startAddRoleWatcher),
    call(startUpdateRoleWatcher),
    call(startDeleteRoleWatcher),
    call(watchFetchRolePermissionIds),
    call(watchUpdateRolePermissions)
  ]);
}

